module.exports = __webpack_public_path__ + "static/media/021-box-5.e256a986.svg";